import Vue from 'vue'
import Router from 'vue-router'
import ExistingAudits from './views/ExistingAudits.vue'
import AuditsToReview from './views/AuditsToReview.vue'
import CurrentAudit from './views/CurrentAudit.vue'
import ReviewCurrentAudit from './views/ReviewCurrentAudit.vue'
import Templates from './views/Templates.vue'
import CurrentTemplate from './views/CurrentTemplate.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/audits'
    },
    {
      path: '/audits',
      name: 'audits',
      component: ExistingAudits,
      props: (route) => ({archived: route.query.archived})
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: AuditsToReview
    },
    {
      path: '/shared',
      name: 'shared',
      component: AuditsToReview,
      props:() => ({completed: true})
    },
    {
      path: '/audit/:auditId',
      name: 'currentAudit',
      component: CurrentAudit
    },
    {
      path: '/reviewAudit/:auditId',
      name: 'reviewAudit',
      component: ReviewCurrentAudit
    },
    {
      path: '/templates',
      name: 'templates',
      component: Templates
    },
    {
      path: '/template/:id',
      name: 'template',
      component: CurrentTemplate,
    }

  ]
})
